import type { ValidationMessageItem } from "@/api_client";
import type {
  EntryPageCommonQuestionBaseValidationMessageItem,
  Maybe,
  QuestionBaseValidationMessageItem,
} from "@/graphql/generated";

export const getErrorMessage = (
  errorMessages: ValidationMessageItem[] | null | undefined,
  errorKey: string,
) => {
  const defaultError = `Missing error for: ${errorKey}`;
  if (!errorMessages) {
    return defaultError;
  }

  const raw = errorMessages.find((item) => item.key?.value === errorKey)
    ?.value as string | { value?: string | null } | null | undefined;
  if (typeof raw === "string") {
    return raw;
  }
  const unwrapped = raw?.value ?? undefined;
  return unwrapped ?? defaultError;
};

export const getErrorMessageNew = (
  errorMessages:
    | Maybe<Maybe<QuestionBaseValidationMessageItem>[]>
    | Maybe<Maybe<EntryPageCommonQuestionBaseValidationMessageItem>[]>
    | undefined,
  errorKey: string,
) => {
  const defaultError = `Missing error for: ${errorKey}`;
  if (!errorMessages) {
    return defaultError;
  }
  return (
    errorMessages?.find((item) => item?.Key === errorKey)?.Value ?? defaultError
  );
};
